import React, { useState } from 'react';
import './Loader.css';
import { BlockUI } from 'primereact/blockui';
import { ProgressSpinner } from 'primereact/progressspinner';

const Loader = ({ loading }) => {
    return (
        <div>
            <BlockUI blocked={loading} fullScreen
                template={
                    <ProgressSpinner
                        style={{ width: '40px', height: '40px' }}
                        strokeWidth="3"
                    />
                }
            />
        </div>
    )
}

export default Loader
